export const frag = /*glsl*/ `
precision mediump float;

uniform sampler2D tNoise;
uniform sampler2D tLinearNoise;

uniform vec3 uColor;
uniform vec3 uMaterialColor;

uniform vec2 uUvScale;
uniform vec2 uMapDirection;

uniform float uVisiblity;

varying vec2 vUv;
varying float vTime;
varying vec3 vPosition;

#define PI 3.141592

float pow2(float x) { return x*x; }
#define FAR 200.

void main(){
	float noise = texture2D(tNoise, (vec2(vPosition.x, vPosition.y * 2.) + vPosition.z) * .0001).r;
	float visibility = 1. - uVisiblity;
	float progress = smoothstep(visibility - .01, visibility, noise);

	if(progress < .01) discard;


	// vec3 base = vec3(.0, .15, .2);
	vec3 base = vec3(.15, .15, .3);
	base += base * smoothstep(.15, 0., length(vec2((vUv.x - .5) * .5 + .5, vUv.y) - vec2(.5, .8)));
	base *= smoothstep(.4, 0., length(vec2((vUv.x - .5) * .5 + .5, vUv.y) - vec2(.5, .75))) * .5;

	float stars = smoothstep(.999, 1., texture2D(tNoise, vUv * 10.).r) * .6;
	stars += smoothstep(.999, 1., texture2D(tNoise, vUv * 5.8).g) * .6;
	stars += smoothstep(.999, 1., texture2D(tNoise, vUv * 4.8).b) * .8;

	base += stars * length(base) * 1.5;
	
	vec3 color = base * .8;
	color = mix(color, uColor, smoothstep(.5, 0., progress));

	gl_FragColor = vec4(color, 1.);
}`;
